/**
 * Фильтры и сортировка каталога банд (docs/team-api.md, §2).
 *
 * Бэкенд принимает только машинные значения — подписи собираются здесь, чтобы
 * панель фильтров, стор и API-слой брали один и тот же список.
 *
 * Пороги уровней и окна активности бэкенд меняет в админке без выката фронта,
 * поэтому **на кнопках не должно быть чисел** — только подписи.
 */

import { MODE_KINDS } from './teamStats'

/** Порядок чипов режимов на экране: сначала популярные, дальше остальные */
export const CATALOG_MODE_KINDS = [
  'case', 'crash', 'casebattle', 'classic', 'double', 'wheel50', 'upgrader', 'contract', 'mines'
]
  .filter((kind) => MODE_KINDS.includes(kind))

export const LEVEL_VALUES = ['novice', 'experienced', 'top']
export const AGE_VALUES = ['new', 'young', 'old']
export const ACTIVITY_VALUES = ['now', 'today', 'week']
export const SORT_VALUES = ['online', 'level', 'likes', 'new']

/**
 * Стартовое состояние экрана: активность не ограничена, полные банды скрыты
 * (`free=1`), сортировка — как было.
 */
export const CATALOG_DEFAULTS = {
  level: null,
  modes: [],
  age: null,
  activity: null,
  free: true,
  sort: 'online'
}

export const levelLabel = (value, t) => {
  const labels = {
    novice: t('team.filters.level.novice', 'Новички'),
    experienced: t('team.filters.level.experienced', 'Опытные'),
    top: t('team.filters.level.top', 'Топ')
  }
  return labels[value] || t('team.filters.anyLevel', 'Любой')
}

export const ageLabel = (value, t) => {
  const labels = {
    new: t('team.filters.age.new', 'Новые'),
    young: t('team.filters.age.young', 'Молодые'),
    old: t('team.filters.age.old', 'Бывалые')
  }
  return labels[value] || t('team.filters.anyAge', 'Любые')
}

export const activityLabel = (value, t) => {
  const labels = {
    now: t('team.filters.activity.now', 'Сейчас'),
    today: t('team.filters.activity.today', 'Сегодня'),
    week: t('team.filters.activity.week', 'Неделя')
  }
  return labels[value] || t('team.filters.activity.all', 'Все')
}

export const sortLabel = (value, t) => {
  const labels = {
    online: t('team.filters.sort.online', 'В сети'),
    level: t('team.filters.sort.level', 'Сильнейшие'),
    likes: t('team.filters.sort.likes', 'Любимые'),
    new: t('team.filters.sort.new', 'Новые')
  }
  return labels[value] || value
}

/** Сколько фильтров отличается от стартового состояния — цифра на кнопке «Фильтры» */
export const activeFilterCount = (filters) => {
  let count = 0
  if (filters.level !== CATALOG_DEFAULTS.level) count += 1
  if (filters.age !== CATALOG_DEFAULTS.age) count += 1
  if (filters.activity !== CATALOG_DEFAULTS.activity) count += 1
  if (filters.free !== CATALOG_DEFAULTS.free) count += 1
  if (filters.modes.length > 0) count += 1
  return count
}

/** Мультивыбор режимов: чип переключает своё значение, порядок не важен */
export const toggleMode = (modes, kind) => (
  modes.includes(kind) ? modes.filter((item) => item !== kind) : [...modes, kind]
)
